export default __webpack_public_path__ + "static/media/boschsans_regularItalic.c909896b.woff2";